import {Injectable} from '@angular/core';
import {RoutesEnums} from '../../../enums/RoutesEnums';
import {LocalStateService} from './local-state.service';
import {RoutingParamsResolveService} from './routing-params-resolve.service';
import {UrlBuilderService} from '../../../services/url-builder.service';
import {SearchResultContent} from '../../../types/SearchResultContent';
import {RedirectService} from '../../../services/redirect.service';
import {ToolsService} from '../../../services/tools.service';
import {SearchState} from '../../../types/SearchState';
import {Params} from '@angular/router';
import {DefaultValuesService} from '../../../services/default-values.service';

@Injectable()
export class SearchRedirectsService {
  constructor(
    private localState: LocalStateService,
    private routingResolveService: RoutingParamsResolveService,
    private urlBuilderService: UrlBuilderService,
    private redirect: RedirectService,
    private tools: ToolsService,
    private defaultValues: DefaultValuesService,
  ) {}

  public conditionalRedirectOnBadStateParams(
    state: SearchState,
    currentParams: Params,
    currentQueryParams: Params,
  ): boolean {
    if (
      state.isRedirectToStateBasedUrlRequired === true ||
      (this.routingResolveService.pageWasSet && state.page === 1)
    ) {
      const routerLink = this.urlBuilderService.CreateSearchResultsRouterLink(state, ['/', RoutesEnums.SEARCH]);
      const queryParams = this.urlBuilderService.CreateSearchResultsQueryParams(state);

      this.redirect.redirect(routerLink, queryParams);
      return true;
    }

    if (!this.localState.searchStateLocal().isValid) {
      this.redirect.redirect(['/', RoutesEnums.NOTFOUND]);
      return true;
    }

    // are query params in the right order and are they equal?
    if (state) {
      const routerLink = this.urlBuilderService.CreateSearchResultsRouterLink(state, ['/', RoutesEnums.SEARCH]);
      const queryParams = this.urlBuilderService.CreateSearchResultsQueryParams(state);

      if (!this.tools.areQueryParamsEqual(queryParams, currentQueryParams)) {
        this.redirect.redirect(routerLink, queryParams);
      }
    }

    return false;
  }

  public RemoveEdgeConditionsFromSearchAndRedirect(searchContent: SearchResultContent, searchQueryDto?: any): void {
    const fallbackFilterApplied = this.localState.RemoveEdgeConditionsFromSearch(searchContent, searchQueryDto);
    let routerLink = this.urlBuilderService.CreateSearchResultsRouterLink(
      this.localState.searchStateLocal(),
      ['/', RoutesEnums.SEARCH],
      fallbackFilterApplied,
    );
    let queryParams = this.urlBuilderService.CreateSearchResultsQueryParams(
      this.localState.searchStateLocal(),
      fallbackFilterApplied,
    );

    // if no search params left, do nothing
    if (routerLink.length <= 1 || (routerLink.length === 3 && Object.keys(queryParams).length === 0)) {
      console.log('########## REDIR', routerLink, queryParams);
      return;
    }

    this.redirect.redirect(routerLink, queryParams);
  }

  public CompareStateWithSearchResponseAndRedirect(searchResultContent: SearchResultContent): boolean {
    if (this.tools.isNil(searchResultContent)) {
      return false;
    }
    const newSearchState = this.tools.clone(this.localState.searchStateLocal());
    const oldFreeSearchTerm = newSearchState.freeSearchTerm;

    if (!this.tools.isNil(searchResultContent.place)) {
      newSearchState.placeUrlPath = searchResultContent.place.urlPath;
    }
    if (!this.tools.isNil(searchResultContent.caregiverUnitType)) {
      newSearchState.caregiverUnitTypeUrlPath = searchResultContent.caregiverUnitType.urlPath;
    }
    if (!this.tools.isNil(searchResultContent.careServiceType)) {
      newSearchState.careServiceTypeUrlPath = searchResultContent.careServiceType.urlPath;
    }
    if (!this.tools.isNil(searchResultContent.symptom)) {
      newSearchState.symptomUrlPath = searchResultContent.symptom.urlPath;
    }
    if (this.tools.isNil(searchResultContent.place)) {
      newSearchState.placeUrlPath = '';
    }
    if (this.tools.isNil(searchResultContent.caregiverUnitType)) {
      newSearchState.caregiverUnitTypeUrlPath = '';
    }
    if (this.tools.isNil(searchResultContent.careServiceType)) {
      newSearchState.careServiceTypeUrlPath = '';
    }
    if (this.tools.isNil(searchResultContent.symptom)) {
      newSearchState.symptomUrlPath = '';
    }

    if (searchResultContent.allSolved === false) {
      newSearchState.freeSearchTerm = searchResultContent.freeText ? searchResultContent.freeText : '';
    } else {
      newSearchState.freeSearchTerm = '';
    }

    if (
      (searchResultContent.allSolved === true ||
        (searchResultContent.allSolved === false && newSearchState.freeSearchTerm === '') ||
        (searchResultContent.allSolved === false &&
          newSearchState.freeSearchTerm !== '' &&
          newSearchState.freeSearchTerm !== oldFreeSearchTerm)) &&
      this.tools.isEqual(this.localState.searchStateLocal(), newSearchState) === false
    ) {
      // redirect chain when interact with search widget is freeSearch -> solved categories,
      // but during freeSearch phase, wrong tab is set
      const defaultSearchState = this.defaultValues.getDefaultSearchState(
        newSearchState.caregiverUnitTypeUrlPath,
        newSearchState.careServiceTypeUrlPath,
        newSearchState.symptomUrlPath,
        newSearchState.freeSearchTerm,
      );
      newSearchState.tab = defaultSearchState.tab;

      let routerLink = this.urlBuilderService.CreateSearchResultsRouterLink(newSearchState, ['/', RoutesEnums.SEARCH]);
      let queryParams = this.urlBuilderService.CreateSearchResultsQueryParams(newSearchState);

      this.redirect.redirect(routerLink, queryParams);
      return true;
    }
    return false;
  }
}
